var exports = {
  "CR": "FollowListModal.module__modalRoot___Y055WF",
  "f5": "FollowListModal.module__restartBar___Y055WF",
  "Qs": "FollowListModal.module__content___Y055WF",
  "Ge": "FollowListModal.module__rows___Y055WF",
  "nM": "FollowListModal.module__row___Y055WF",
  "Cd": "FollowListModal.module__userButton___Y055WF",
  "Dy": "FollowListModal.module__names___Y055WF",
  "QC": "FollowListModal.module__displayName___Y055WF",
  "Tc": "FollowListModal.module__tag___Y055WF",
  "DT": "FollowListModal.module__removeButton___Y055WF",
  "Yz": "FollowListModal.module__removeIcon___Y055WF",
  "h5": "FollowListModal.module__status___Y055WF",
  "qS": "FollowListModal.module__statusText___Y055WF",
};

module.exports = exports;
